import { processor } from './processor.js';
import { TemplateResult } from './template-result.js';
export function html(strings, ...values) {
    return new TemplateResult(strings, values, processor);
}
//# sourceMappingURL=html.js.map